import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebaseOptions';
import './ProjectDetail.css';

export default function ProjectDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedMedia, setSelectedMedia] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const docRef = doc(db, 'albums', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setProject({ id: docSnap.id, ...docSnap.data() });
        } else {
          console.log('No such document!');
          navigate('/');
        }
      } catch (error) {
        console.error('Error fetching project', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProject();
  }, [id, navigate]);

  if (loading) return <div className="loading-screen">Cargando...</div>;
  if (!project) return null;

  return (
    <div className="project-detail-container">
      <header className="project-header">
        <h1 className="project-title">{project.title}</h1>
        <span className="project-category">{project.category}</span>
      </header>

      <div className="project-gallery">
        {project.images?.map((url, index) => {
          const isVideo =
            url.includes('.mp4') ||
            url.includes('.webm') ||
            url.includes('.mov');
          return (
            <div
              key={index}
              className="gallery-item"
              onClick={() => setSelectedMedia(url)}
            >
              {isVideo ? (
                <video
                  src={url}
                  muted
                  playsInline
                  className="gallery-video-preview"
                />
              ) : (
                <img src={url} alt={`${project.title} ${index}`} />
              )}
            </div>
          );
        })}
      </div>

      <div className="back-nav">
        <button onClick={() => navigate('/')}>← VOLVER</button>
      </div>

      {/* LIGHTBOX */}
      {selectedMedia && (
        <div
          className="lightbox-backdrop"
          onClick={() => setSelectedMedia(null)}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedMedia.includes('.mp4') ||
            selectedMedia.includes('.webm') ||
            selectedMedia.includes('.mov') ? (
              <video
                src={selectedMedia}
                controls
                autoPlay
                className="lightbox-media"
              />
            ) : (
              <img
                src={selectedMedia}
                alt="Full screen"
                className="lightbox-media"
              />
            )}
            <button
              className="lightbox-close"
              onClick={() => setSelectedMedia(null)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
